import React, { useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "../lib/i18n";
import api from "../lib/api";
import StarRating from "./StarRating";

export default function ReviewModal({ open, onClose, context, onDone }) {
  const { t } = useI18n();
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  if (!open || !context) return null;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/reviews", {
        context_type: context.context_type,
        context_id: context.context_id,
        rating,
        comment: comment || null,
      });
      toast.success(t("review_submitted"));
      onDone?.();
      onClose();
      setRating(5); setComment("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("error_generic"));
    } finally { setBusy(false); }
  };

  return (
    <div
      data-testid="review-modal"
      className="fixed inset-0 bg-black/70 flex items-center justify-center p-4"
      style={{ zIndex: 10001 }}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg max-w-md w-full p-6 border border-[#E6E2D8]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between">
          <div>
            <div className="overline text-[#143122]">
              {context.context_type === "booking" ? t("review_booking") : context.context_type === "completion" ? t("review_completion") : t("review_deal")}
            </div>
            <h3 className="mt-1 font-serif-display text-2xl text-[#143122]">
              {t("review_of")} {context.subject_name}
            </h3>
            <div className="text-xs text-[#1A1F1C]/60 mt-1">{context.title}</div>
          </div>
          <button data-testid="review-modal-close" onClick={onClose} className="text-[#1A1F1C]/60 hover:text-[#143122]">
            <X size={20} strokeWidth={1.5} />
          </button>
        </div>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="block text-sm font-medium mb-2">{t("rating")}</label>
            <StarRating value={rating} onChange={setRating} size={28} />
            <div className="mt-2 text-xs text-[#1A1F1C]/55">{t("rating_legend")}</div>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1.5">{t("comment_optional")}</label>
            <textarea
              data-testid="review-comment"
              rows={4}
              className="kav-input"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder={t("review_placeholder")}
            />
          </div>
          <button data-testid="review-submit-btn" type="submit" disabled={busy} className="kav-btn-primary w-full justify-center">
            {busy ? "..." : t("submit_review")}
          </button>
        </form>
      </div>
    </div>
  );
}
